module.exports = __webpack_public_path__ + "media/images/pic/home_hero-f4448c614665cd58c9a0bd7a42ac7534.svg";